import $ from 'jquery';

class Like {

    constructor() {
        this.heartIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"/></svg>'
        this.heartLikedIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"/></svg>'
        this.thumnbIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M144 224C161.7 224 176 238.3 176 256L176 512C176 529.7 161.7 544 144 544L96 544C78.3 544 64 529.7 64 512L64 256C64 238.3 78.3 224 96 224L144 224zM334.6 80C361.9 80 384 102.1 384 129.4L384 133.6C384 140.4 382.7 147.2 380.2 153.5L352 224L512 224C538.5 224 560 245.5 560 272C560 291.7 548.1 308.6 531.1 316C548.1 323.4 560 340.3 560 360C560 383.4 543.2 402.9 521 407.1C525.4 414.4 528 422.9 528 432C528 454.2 513 472.8 492.6 478.3C494.8 483.8 496 489.8 496 496C496 522.5 474.5 544 448 544L360.1 544C323.8 544 288.5 531.6 260.2 508.9L248 499.2C232.8 487.1 224 468.7 224 449.2L224 262.6C224 247.7 227.5 233 234.1 219.7L290.3 107.3C298.7 90.6 315.8 80 334.6 80z"/></svg>'
        this.events();
    }

    events() {

       // $(document).on('click', '.likes-total', this.toggleLike.bind(this))
        $(document).on('click', '.likes-total', this.toggleLikesDiv.bind(this))
        $(document).on('click', 'ul.reactions-icons li', this.addRemoveLike.bind(this))
    }
    updateScoreText(score){
        $('#rewards').html(score)
    }
    toggleLikesDiv(e){
        e.stopPropagation()
        const $triggerDiv = $(e.currentTarget)
        let id = $triggerDiv.data('id')
        const $target = $('.reactions-list[data-id="' + id + '"]')
        $target.slideToggle(400)
        $(document).on('click.hideReactions', function(event) {

            if (!$(event.target).closest('.likes-total, .reactions-list').length) {
                $target.slideUp(400)
                $(document).off('click.hideReactions')
            }
        })
    }

    addRemoveLike(e){
        const $trigger = $(e.currentTarget)
        let reaction = $trigger.data('reaction')
        let postId   = $trigger.data('post-id')
        let mainId = $trigger.data('main-id')
        let userId   = $trigger.data('user-id')
        const likesDiv = $(`.likes-total[data-id="${postId}"]`)
        let liked = likesDiv.data('current')
        const rewards = $('#rewards')
        console.log(mainId)
        //console.log('Liked:', likesDiv.data('current'))
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_add_multi_like',
                nonce: ptdfNetworkAjax.nonce,
                activity_id: postId,
                main_id: mainId,
                user_id: userId,
                reaction_id: reaction,
                liked
            },
            success: (response) => {
                likesDiv.removeClass('loading')
                //console.log(response)
                if (response.success) {
                    console.log(response)
                    const score = response.data.score
                    if(typeof score === 'number'){
                        this.updateScoreText(score)
                    }
                    const action = response.data.action
                    const likeUrl = response.data.like_url
                    const total = response.data.total_count
                    likesDiv.data('count', total).attr('data-count', total)
                    likesDiv.find('.likes-count').text(total)
                    const likeIcon = likesDiv.find('.likeIcon')
                    if(action === 'changed' || action === 'added'){
                        likeIcon.html(
                            `
                            <img src="${likeUrl}" class="img-fluid"/>
                            `
                        )
                    }else if(action === 'removed'){
                        likeIcon.html(
                            this.thumnbIcon
                        )
                    }
                }
            },
            error: () => {
                likesDiv.removeClass('loading')

            }
        })
    }


    //instagram approach
    toggleLike(e) {
        const $likeDiv = $(e.currentTarget)
        const isLiked = $likeDiv.data('current') === true || $likeDiv.data('current') === 'true'
        const activityId = $likeDiv.data('id')
        const userId = $likeDiv.data('user')
        const reactionId = 1

        $likeDiv.addClass('loading')

        let action = isLiked ? 'ptdf_remove_like' : 'ptdf_add_like'
        //console.log(ptdfNetworkAjax)
        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: action,
                nonce: ptdfNetworkAjax.nonce,
                activity_id: activityId,
                user_id: userId,
                reaction_id: reactionId
            },
            success: (response) => {
                $likeDiv.removeClass('loading')
                if (response.success) {
                    const count = response.data.count
                    $likeDiv.data('count', count).attr('data-count', count)
                    $likeDiv.find('.likes-count').text(count)

                    if (response.data.status === 'added') {
                        $likeDiv.data('current', 'true').attr('data-current', 'true')
                        this.setIcon($likeDiv, this.heartLikedIcon)
                    } else {
                        $likeDiv.data('current', 'false').attr('data-current', 'false')
                        this.setIcon($likeDiv, this.heartIcon)
                    }
                }
            },
            error: () => {
                $likeDiv.removeClass('loading')
                // Optionally show error
            }
        })
    }

    setIcon($div, iconSVG) {
        // Replace only the SVG inside (assumes structure: <div>SVG X</div>)
        // If you have a number after the SVG (like ...SVG X 10</div>), update only the SVG
        // So, find the first SVG and replace its outerHTML
        const html = $div.html()
        const updated = html.replace(/<svg[\s\S]*?<\/svg>/, iconSVG)
        $div.html(updated)
    }
}

export default Like